import { Tooltip, Typography, useTheme } from "@mui/material";
import {
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid/models";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React from "react";

interface Props {
  val: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>;
  withTime?: boolean;
}

export default function RenderDate({ val, withTime = false }: Props) {
  const theme = useTheme();

  const formatDate = (value: any) => {
    if (!value) return "--";

    dayjs.extend(utc);
    // Handle Firestore timestamp
    if (value._seconds) {
      return dayjs(value._seconds * 1000)
        .utc()
        .format(withTime ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY");
    }

    // Handle regular date
    return dayjs(value)
      .utc()
      .format(withTime ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY");
  };

  return (
    <Tooltip
      placement="top"
      title={
        <React.Fragment>
          <b>
            <em>{formatDate(val.value)}</em>
          </b>
        </React.Fragment>
      }
    >
      <Typography
        variant="body1"
        color={theme.palette.mode === "dark" ? "white" : "black"}
      >
        {formatDate(val.value)}
      </Typography>
    </Tooltip>
  );
}
